import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectImplant3dScanTable(state),
        type: 'implant-3d-scan',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryImplant3dScan,
    changeFilter: action.changeFilterImplant3dScan,
    toggleSort: action.toggleSortImplant3dScan,
    toggleMultiSort: action.toggleMultiSortImplant3dScan,
    gotoPage: action.gotoPageImplant3dScan,
    initialColumnsVisibility: action.initialTableSettingsImplant3dScan,
    toggleColumnVisibility: action.toggleColumnVisibilityImplant3dScan,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/Implant3DScanSalesOrderSearchContainer.js